import axios from "axios";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { HTTP_STATUSES, STANDARD_ERRORS_WAY } from "../../../../utils/consts";
import { fetchFilterData } from "../../../../utils/fetchFilterData";
import { parseAxiosError } from "../../../../utils/response";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import { StyledAboutOfProfit, StyledCashFlowProfitListItem } from "../../../cashFlow/admin/profit/styledCashFlowProfit";
import { StyledCol, StyledTableRow } from "../../../styles/styledTable";
import ExchangeProfitItemDetailsList from "./exchangeProfitDetails/ExchangeProfitItemDetailsList";

const ExchangeProfitItem = ({ value, notification, setNotification, filterData, t }) => {
  const history = useHistory();

  const DEFAULT_ITEMS_PER_PAGE = 100;

  const [showDetails, setShowDetails] = useState(false);
  const [profitDetails, setProfitDetails] = useState(null);

  const handleShowDetails = (e, id) => {
    if (e.target.tagName === "DIV") {
      history.push(`/exchange-profit-details/${id}`);
    }
  };

  const fetchProfitDetails = () => {
    let filterUrl = fetchFilterData({
      ...filterData,
      currency: value.currency,
      service: value.service,
      byClient: "1",
      itemsPerPage: DEFAULT_ITEMS_PER_PAGE
    });

    axios.get("/api/exchanges/profits" + filterUrl, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        setProfitDetails(response.data["profits"]);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  const showProfitDetails = () => {
    setShowDetails(!showDetails);

    if (!showDetails) {
      fetchProfitDetails();
    }
  };

  return (
    <StyledCashFlowProfitListItem>
      <StyledTableRow
        onClick={(e) => showProfitDetails(e, value)}
        col="3"
        scroll="auto"
        cursor="pointer"
        className="profit-list-table__row"
      >
        <StyledCol data-title={t("profit.table.service")}>
          {value.service}
        </StyledCol>
        <StyledCol data-title={t("profit.table.currency")}>
          {value.currency}
        </StyledCol>
        <StyledCol data-title={t("profit.table.amount")} inline>
          <StyledAboutOfProfit color={value.profit > 0 ? "green" : value.profit < 0 ? "red" : "transparent"}>
            {value.profit ?? 0} {value.currency}
          </StyledAboutOfProfit>
        </StyledCol>
      </StyledTableRow>
      {showDetails && <ExchangeProfitItemDetailsList profitDetails={profitDetails} filterData={filterData} t={t} />}
    </StyledCashFlowProfitListItem>
  );
};

export default ExchangeProfitItem;